import moment from "moment";

export const adaptCondicionesGeneralesRIResumen = data => {
    const {
        evaluacionFamiliaPsicosicial,
        consentimientoOutput,
        idComboRIValorFasePacienteNavigation,
        fechaFirmaConsentimiento,
        ...condicionesGenerales
    } = data;

    return {
        ...condicionesGenerales,
        evaluacionFamiliaPsicosocial: evaluacionFamiliaPsicosicial,
        idComboRIValorFasePaciente: idComboRIValorFasePacienteNavigation?.valor,
        fechaFirmaConsentimiento: ((fechaFirmaConsentimiento!=null) && (fechaFirmaConsentimiento!=""))?moment(fechaFirmaConsentimiento).format("DD/MM/YYYY"):"",
        consentimientoInput: consentimientoOutput ? {
            contentType: consentimientoOutput?.contentType,
            titulo: consentimientoOutput?.titulo,
            archivo: consentimientoOutput?.archivo,
            extension: consentimientoOutput?.extension
        } : null,
    }
}